import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "font-resize-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.2777 6.2675C17.1641 5.98204 16.888 5.79469 16.5808 5.79468C16.2736 5.79467 15.9974 5.98201 15.8839 6.26746L11.5537 17.1532C11.4006 17.5381 11.5885 17.9742 11.9733 18.1273C12.3582 18.2804 12.7943 18.0925 12.9474 17.7077L13.625 16.0043H19.5359L20.2141 17.7093C20.3672 18.0942 20.8033 18.2822 21.1882 18.1291C21.5731 17.976 21.761 17.5399 21.6079 17.155L17.2777 6.2675ZM18.9394 14.5043H14.2217L16.5807 8.57394L18.9394 14.5043Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.95414 9.559C6.84415 9.30096 6.59073 9.1335 6.31023 9.13349C6.02972 9.13348 5.77629 9.30093 5.66628 9.55896L2.3961 17.2294C2.24449 17.585 2.40987 17.9963 2.7655 18.1479C3.12113 18.2995 3.53233 18.1341 3.68395 17.7785L4.15628 16.6706H8.46369L8.93645 17.7796C9.08805 18.1353 9.49924 18.3007 9.85488 18.1491C10.2105 17.9975 10.3759 17.5863 10.2243 17.2307L6.95414 9.559ZM7.86691 15.2706L6.31015 11.6185L4.75315 15.2706H7.86691Z"
    }, null, -1)
  ])))
}
export default { render: render }